import { styled } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import * as bannerContent from 'assets/content/banner';

// Banners (top level wrapper)
export const BaseBanner = styled('div')(({ theme, props }) => ({
  ...theme.typography.p2,
  width: '100vw',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  transition: 'background 0.3s ease',
  color: theme.palette.common.white.light,
  height: theme.props.bannerHeight,
  [theme.breakpoints.match('md')]: {
    justifyContent: props?.hasLink ? 'space-between' : 'center',
    paddingLeft: props?.hasLink ? 20 : 'inherit',
  },
  [theme.breakpoints.match('sm')]: {
    justifyContent: 'center',
    paddingLeft: 'inherit',
  },
  '& em': {
    fontStyle: 'normal',
    textDecoration: 'underline',
  },
}));

export const LoadingBanner = styled(BaseBanner)(({ theme }) => ({
  background: theme.palette.backgrounds.white,
}));

export const DefaultBanner = styled(BaseBanner)(({ theme }) => ({
  background: theme.palette.backgrounds.noir,
}));

export const GiveawayBanner = styled(BaseBanner)({
  background: '#6a6e5c',
});

export const MembershipCheckoutBanner = styled(BaseBanner)(({ theme }) => ({
  backgroundColor: theme.palette.backgrounds.lime,
  color: theme.palette.common.noir.dark,
}));

export const MembershipCtaBanner = styled(BaseBanner)(({ theme }) => ({
  backgroundColor: theme.palette.backgrounds.lime,
  color: theme.palette.common.noir.dark,
}));

// Links second level components
export const LinkCta = styled(Link)(({ theme }) => ({ color: theme.palette.common.white.light }));

export const LinkCtaNoir = styled(Link)(({ theme }) => ({
  color: theme.palette.common.noir.medium,
}));

const LongLinkCta = styled(Link)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  color: theme.palette.common.white.light,
  textDecoration: 'underline',
  letterSpacing: '0.5px',

  [theme.breakpoints.up('xs')]: {
    display: 'block',

    borderBottom: '1px solid white',
    lineHeight: '10px',

    textDecoration: 'none',
  },
}));

// Side CTA Components
const DesktopBannerSideCTA = styled('div')(({ theme }) => ({
  display: 'flex',
  height: theme.props.bannerHeight,
  paddingTop: 10,
  position: 'absolute',
  right: 20,
  [theme.breakpoints.match('sm')]: {
    display: 'none',
  },
}));

export const DefaultBannerContent = () => (
  <LongLinkCta data-click="refer" data-from="banner" data-testid="default-banner" to="/reviews">
    {bannerContent.defaultContent}
  </LongLinkCta>
);

export const ReferFriendSideLink = () => (
  <DesktopBannerSideCTA>
    <LinkCtaNoir
      data-click="refer"
      data-from="banner"
      data-testid="referral-cta-side-banner"
      to="/account/refer-a-friend"
    >
      {bannerContent.referralCta}
    </LinkCtaNoir>
  </DesktopBannerSideCTA>
);
